// libs
import cx from 'classnames';
import React, { forwardRef, memo, useImperativeHandle, useMemo, useState, } from 'react';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { DlsFontVariants } from '@/constants/DLSTokens';
// styles
import styles from './TabsNavigator.module.scss';
const TabsNavigator = forwardRef(({ config, selectedId }, ref) => {
    var _a;
    const [activeId, setActiveId] = useState(selectedId !== null && selectedId !== void 0 ? selectedId : (_a = config[0]) === null || _a === void 0 ? void 0 : _a.id);
    const activeConfig = useMemo(() => config.find((c) => c.id === activeId), [activeId, config]);
    useImperativeHandle(ref, () => ({
        setActiveTabId: (id) => {
            setActiveId(id);
        },
        getActiveTabId: () => activeId,
    }), [activeId, setActiveId]);
    if (activeConfig == undefined)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.container },
            React.createElement("div", { className: styles.tabs }, config.map((tile) => {
                var _a;
                return (React.createElement("div", { key: tile.id, className: cx(styles.tab, {
                        [styles.tabActive]: tile.id === activeId,
                    }), onClick: () => setActiveId(tile.id) },
                    ((_a = tile.tabOptions) === null || _a === void 0 ? void 0 : _a.Icon) && (React.createElement(tile.tabOptions.Icon, { className: styles.tabIcon, fillColor: styles.colorBlack })),
                    React.createElement(Text, { variant: DlsFontVariants.button_Text_BT5 }, tile.tabLabel),
                    React.createElement("div", { className: cx(styles.tabIndicator, {
                            [styles.tabIndicatorVisible]: activeId === tile.id,
                        }) })));
            })),
            React.createElement("div", { className: styles.tabsContainer }, config.map((tile) => (React.createElement("div", { className: cx(styles.content, {
                    [styles.contentHidden]: tile.id !== activeConfig.id,
                }), key: tile.id },
                React.createElement(tile.Content, Object.assign({}, tile.contentProps, { ref: tile.ref })))))))));
});
export default memo(TabsNavigator);
